import { subscribe, publish } from '@wh/message-bus';
import { openLink } from '../../utils';

export const helpMenuPlugin = {
  beforeRender() {
    if (process.env.RUNTIME !== 'browser') {
      return;
    }
    subscribe('wh.common.event.ui.header.sub-menu-end.requested', (_topic, data) => {
      if (data.id === 'help-and-support.feedback') {
        publish({ topic: 'feedback.open' });
      } else if (data.id === 'help-and-support.live-person') {
        publish({ topic: 'live-person.open' });
      } else if (data.id === 'help-and-support.live-messaging') {
        publish({ topic: 'live-messaging.open' });
      } else if (
        ['help-and-support.live-chat', 'help-and-support.help', 'help-and-support.contact-us'].includes(data.id)
      ) {
        openLink(data.link);
      }
    });
  },
};
